import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { configureBranchInheritanceThunk } from '../../store/thunks/rateThunks';

const InheritanceSettings = ({ branchCode, isMainBranch, inheritanceSettings = {} }) => {
  const dispatch = useDispatch();
  const [settings, setSettings] = useState({
    inheritFromMain: inheritanceSettings.inheritFromMain || false,
    inheritFromBranch: inheritanceSettings.inheritFromBranch || '',
    customAdjustments: {
      goldAdjustment: inheritanceSettings.customAdjustments?.goldAdjustment || 0,
      silverAdjustment: inheritanceSettings.customAdjustments?.silverAdjustment || 0,
      transportCost: inheritanceSettings.customAdjustments?.transportCost || 0
    }
  });

  const handleSave = async () => {
    await dispatch(configureBranchInheritanceThunk({
      branchCode,
      inheritanceData: settings
    }));
  };

  if (isMainBranch) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <h3 className="font-semibold text-yellow-900 mb-2">Main Branch</h3>
        <p className="text-sm text-yellow-700">
          This is the main branch. Other branches can inherit rates from here.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-lg">Inheritance Settings</h3>
      
      <div className="space-y-3">
        <div className="flex items-center">
          <input
            type="checkbox"
            id="inheritFromMain"
            checked={settings.inheritFromMain}
            onChange={(e) => setSettings(prev => ({ 
              ...prev, 
              inheritFromMain: e.target.checked,
              inheritFromBranch: e.target.checked ? '' : prev.inheritFromBranch
            }))}
            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <label htmlFor="inheritFromMain" className="ml-2 text-sm">
            Inherit rates from main branch
          </label>
        </div>

        {!settings.inheritFromMain && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Or inherit from specific branch
            </label>
            <input
              type="text"
              value={settings.inheritFromBranch}
              onChange={(e) => setSettings(prev => ({ 
                ...prev, 
                inheritFromBranch: e.target.value 
              }))}
              placeholder="Enter branch code"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
        )}
      </div>

      {(settings.inheritFromMain || settings.inheritFromBranch) && (
        <div className="bg-gray-50 rounded-lg p-4 space-y-3">
          <h4 className="font-medium">Custom Adjustments</h4>
          
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="block text-sm text-gray-600 mb-1">
                Gold Adjustment (₹/gm)
              </label>
              <input
                type="number"
                value={settings.customAdjustments.goldAdjustment}
                onChange={(e) => setSettings(prev => ({
                  ...prev,
                  customAdjustments: {
                    ...prev.customAdjustments,
                    goldAdjustment: parseFloat(e.target.value) || 0
                  }
                }))}
                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                step="0.01"
              />
            </div>
            
            <div>
              <label className="block text-sm text-gray-600 mb-1">
                Silver Adjustment (₹/gm)
              </label>
              <input
                type="number"
                value={settings.customAdjustments.silverAdjustment}
                onChange={(e) => setSettings(prev => ({
                  ...prev,
                  customAdjustments: {
                    ...prev.customAdjustments,
                    silverAdjustment: parseFloat(e.target.value) || 0
                  }
                }))}
                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                step="0.01"
              />
            </div>
            
            <div>
              <label className="block text-sm text-gray-600 mb-1">
                Transport Cost (₹/gm)
              </label>
              <input
                type="number"
                value={settings.customAdjustments.transportCost}
                onChange={(e) => setSettings(prev => ({
                  ...prev,
                  customAdjustments: {
                    ...prev.customAdjustments,
                    transportCost: parseFloat(e.target.value) || 0
                  }
                }))}
                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                step="0.01"
              />
            </div>
          </div>
          
          <p className="text-xs text-gray-500">
            These adjustments will be added to the inherited base rates
          </p>
        </div>
      )}

      <div className="flex justify-end">
        <button
          onClick={handleSave}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Save Settings
        </button>
      </div>
    </div>
  );
};

export default InheritanceSettings;